/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {registerLocaleData} from '@angular/common';
import localeDeCh from '@angular/common/locales/de-CH';
import localeEn from '@angular/common/locales/en';
import localeDeChExtra from '@angular/common/locales/extra/de-CH';
import localeEnExtra from '@angular/common/locales/extra/en';
import localeFrChExtra from '@angular/common/locales/extra/fr-CH';
import localeItChExtra from '@angular/common/locales/extra/it-CH';
import localeFrCh from '@angular/common/locales/fr-CH';
import localeItCh from '@angular/common/locales/it-CH';
import {enableProdMode, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog';
import {bootstrapApplication} from '@angular/platform-browser';
import {ServiceWorkerModule} from '@angular/service-worker';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';

import {AppRoutingModule} from './app/app-routing.module';
import {AppComponent} from './app/app.component';
import {CoreModule} from './app/core/core.module';
import {KorrespondenzSprache} from './app/core/sprache.enum';
import {DataStoreModule} from './app/data-store/data-store.module';
import {SharedModule} from './app/shared/shared.module';
import {ToolbarModule} from './app/toolbar/toolbar.module';
import {environment} from './environments/environment';

registerLocaleData(localeDeCh, KorrespondenzSprache.DE, localeDeChExtra);
registerLocaleData(localeFrCh, KorrespondenzSprache.FR, localeFrChExtra);
registerLocaleData(localeItCh, KorrespondenzSprache.IT, localeItChExtra);
registerLocaleData(localeEn, KorrespondenzSprache.EN, localeEnExtra);

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(
            // Core & Shared
            CoreModule.forRoot(),
            SharedModule,

            AppRoutingModule,

            DataStoreModule,
            ToolbarModule,

            ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
            NgxExtendedPdfViewerModule,
        ),
        // Insert Core Angular Providers here
        {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {maxWidth: 1024}},
    ],
})
    .catch((err: unknown) => console.log('App bootstrap error: ', err));
if (document.title.indexOf(environment.version) === -1) {
    document.title += ` - Version ${(environment.version)}`;
}
